module.exports = __webpack_public_path__ + "static/img/banner1.4b36849.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/banner1.jpg
// module id = hEo+
// module chunks = 1